<template>
    <div>
        <div class=" container-fluid   ">
        <div class="llp-container-section  heightcontainer ">
        <top-header id="height2"></top-header>
      <main-menu id="height3"></main-menu>
        <div id="activity" class="container-fluid menu-margin-top" style="padding-left:0px;padding-right:0px">
            <div>
                <nav class="navbar navbar-expand-lg bg-info text-white">
                    <span><b>Update Task</b></span>
                </nav>
                <br />
                <div v-if="saved">
                    <p align="center" class="confirm-message">{{task.message}}</p>
                </div>
                <div v-if="failure">
                    <p align="center" class="alert-danger">{{selectedTask.failureMessage}}</p>
                </div>
                 <div>

   <button type = "button" @click ="setMyDateToToday" style="width:3%;margin-right:1%" class="btn-blue-save"><</button>

  <label>Start Of Week</label>

  <label  style="margin-left:1.5%">{{task.weekStart | moment("MM/DD/YYYY")}}</label>

  <label style="margin-left:3%">End Of Week</label>

  <label style="margin-left:1.5%">{{task.weekEnd| moment("MM/DD/YYYY")}}</label>

  <button type = "button" @click ="addADayToMyDate" style="width:3%;margin-left:1%" class="btn-blue-save">></button>

</div>

                <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 p-2">
                    <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                        <label class="col-form-label col-form-label-sm">Salesperson Name</label>
                    </div>
                    <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                        <select v-if="this.disableemployeedd" data-vv-name="Employee" class="form-control input-sm" v-validate="'required'" v-model.trim="task.empId" disabled>
                            <option selected v-for="emp in employeelist" v-bind:value="emp.employeeId" v-bind:key="emp.employeeId"> {{ emp.firstName }},{{ emp.lastName }} </option>
                        </select>
                       <!-- <select v-else v-model="selectedName" class="form-control input-sm" @[change]="displayTasks">
                            <option disabled value="">Select</option>
                            <option value="All">All</option>
                            <option v-for="employee in employeelist" :value="employee.employeeId">{{employee.firstName}},{{employee.lastName}}</option>
                        </select>-->
                          <multiselect
    style="width:100%"
    v-else
    v-model="selectedName"
    @input="displayTasks"
    :options="employeelist"
    placeholder="Select Employee"
   :value="employeelist.employeeId"
    :custom-label="displayFullName"
    selected="selected"
    id="statesdd">
    <div slot="beforeList">

                               <span  @click="selectAllOption">All</span>
                            </div>
  </multiselect>
                    </div>
                </div>
                <br />
                <br />
                <div class="row p-2 justify-content-center">
                    <div class="col">
                        <div class="table-responsive table-responsive-sm tbl-update-dealer">
                  <v-table
                    id="tasklist"
                    :data="taskList"
                    class="table table-sm table-bordered table-striped"
                  >
                  <thead class="table-month-header-blue wrap-text" slot="head">
                      <v-th sortKey="agentTaskId">Select</v-th>
                      <v-th sortKey="startOfWeek">Schedule Week</v-th>
                      <v-th sortKey="employee.firstName">Salesperson Name</v-th>
                      <v-th sortKey="activityTaskX">Activity Task</v-th>
                      <v-th sortKey="dealerName">Dealer Name</v-th>
                      <v-th sortKey="eventType">Event Type</v-th>
                      <v-th sortKey="shortNotes">Short Note</v-th>
                      <v-th sortKey="agentTaskId">Action</v-th>
                                </thead>
                                <tbody slot="body" slot-scope="{ displayData }">
                                    <tr v-for="(tsk,index) in displayData " :class="colorRow(tsk.agentTaskId)" :key="index">
                                        <td>
                                            <input type="radio" v-model="selectedRadio" v-on:click="viewAppDetails(tsk.agentTaskId,index)" v-bind:value="tsk.agentTaskId" name="tab" />
                                        </td>
                                        <td>{{tsk.startOfWeek| moment("MM/DD/YYYY")}} to {{tsk.endOfWeek| moment("MM/DD/YYYY")}}</td>
                                        <td>{{tsk.employee.firstName}} {{tsk.employee.lastName}}</td>
                                        <td>{{tsk.activityTaskX}}</td>
                                        <td>{{tsk.dealerName}}</td>
                                        <td>{{tsk.eventType}}</td>
                                        <td>{{tsk.taskCompletionFlag}}</td>
                                        <td>{{tsk.lastUpdatedD | moment("MM/DD/YYYY hh:mm:ss")}}</td>
                                    </tr>
                                </tbody>
                            </v-table>
                            </div>
                    </div>
                </div>
                <div v-if="selectedTask.activityTaskD === 'EDV'">
                    <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 p-2">

                        <div class="col-lg-3 col-md-12 col-sm-3 d-flex justify-content-start align-items-center">
                            <input type="checkbox" id="askdecline" v-model="checked" class="pr-2" disabled />
                            <label class="form-check-label required ml-2" for="askdecline"> Ask for Declines</label>
                        </div>
                        <!-- col end-->
                        <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                            <input
                                type="text"
                                class="form-control input-sm"
                                placeholder="Enter Ask For Declines"
                                v-validate="'required'"
                                v-model.trim="selectedTask.trackerPaperWork"
                                data-vv-name="declines"
                                autocomplete="true"
                                :maxlength="50"
                            />
                            <div v-if="errors.has('declines')" class="alert-danger">{{ errors.first('declines') }}</div>
                        </div>
                        <!-- col end-->
                    </div>
                    <!-- row end-->
                    <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 p-2">

                        <div class="col-lg-3 col-md-12 col-sm-3 d-flex justify-content-start align-items-center">
                            <input type="checkbox" v-model="checked" class="pr-2" disabled />
                            <label class="form-check-label required ml-2">Make sure documents are filled</label>
                        </div>
                        <!-- col end-->
                        <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                            <select v-validate="'required'" placeholder="Select" class="form-control input-sm" data-vv-name="Document" v-model.trim="selectedTask.uDocumentFillStatus">
                                <option :value="null" disabled>Select Yes/No</option>
                                <option v-for="(documentdata,index) in documentlist" v-bind:value="documentdata.key" v-bind:key="documentdata.key">{{documentdata.value}}</option>
                            </select>
                            <div v-if="errors.has('Document')" class="alert-danger">{{ errors.first('Document') }}</div>
                        </div>
                        <!-- col end-->
                    </div>
                    <!--row end-->
                    <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 p-2">

                        <div class="col-lg-3 col-md-12 col-sm-3 d-flex justify-content-start align-items-center">
                            <input type="checkbox" v-model="checked" class="pr-2" disabled />
                            <label class="form-check-label required ml-2">VAIG (tell us who and contact info)</label>
                        </div>
                        <!-- col end-->
                        <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                            <input type="text" v-validate="'required'" class="form-control input-sm" placeholder="Enter VAIG" data-vv-name="vaig" v-model.trim="selectedTask.uVaigContact" />
                            <div v-if="errors.has('vaig')" class="alert-danger">{{ errors.first('vaig') }}</div>
                        </div>
                        <!-- col end-->
                    </div>
                    <!--row end-->
                    <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 p-2">
                        <div class="col-lg-3 col-md-12 col-sm-3 d-flex justify-content-start align-items-center">
                            <input type="checkbox" v-model="checked" class="pr-2" disabled />
                            <label for="inventory" class="form-check-label ml-2">Scan Inventory</label>
                        </div>
                        <!-- col end-->

                        <!-- col end-->
                        <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                            <input type="text" placeholder="Enter Scan Inventory" class="form-control input-sm" v-model="selectedTask.uInventoryDetails" />
                        </div>
                        <!-- col end-->
                    </div>
                    <!--row end-->
                    <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 p-2">

                        <div class="col-lg-3 col-md-12 col-sm-2 d-flex justify-content-start align-items-center">
                            <input type="checkbox" v-model="checked" class="pr-2" disabled />
                            <label for="agree" class="form-check-label ml-2">Spend time with Sales and F&I</label>
                        </div>
                        <!-- col end-->
                        <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                            <select v-model="selectedTask.uSpendTimeResponse" class="form-control input-sm">
                                <option :value="null" disabled>Select</option>
                                <option>No</option>
                                <option>YES F&I</option>
                                <option>Yes Sales</option>
                                <option>Yes Both</option>
                            </select>
                        </div>
                        <!-- col end-->
                        <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                            <input type="text" class="form-control input-sm" v-model="selectedTask.uSpendTimeDetails" />
                        </div>
                        <!-- col end-->
                    </div>
                    <!--row end-->
                    <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 p-2">

                        <div class="col-lg-3 col-md-12 col-sm-2 d-flex justify-content-start align-items-center">
                            <input type="checkbox" v-model="checked" class="pr-2" disabled />
                            <label for="agree" class="form-check-label ml-2">Re-establish Credit Relationship</label>
                        </div>
                        <!-- col end-->
                        <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                            <select v-model="selectedTask.uCreditRelationshipResponse" class="form-control input-sm">
                                <option :value="null" disabled>Select</option>
                                <option>No, Already Engaged</option>
                                <option>Yes, left Card</option>
                                <option>Yes, Called Credit</option>
                                <option>Yes, Credit Follow-up</option>
                            </select>
                        </div>
                        <!-- col end-->
                        <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                            <input type="text" v-model="selectedTask.uCreditRelationshipDetails" class="form-control input-sm" />
                            <!-- <input type="text"    v-model="selectedTask.uCreditRelationshipDetails" :hidden="!reestablish" v-else>-->
                        </div>
                        <!-- col end-->
                    </div>
                    <!--row end-->
                    <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 p-2">
                        <div class="col-lg-1 col-md-1 col-sm-1 d-flex justify-content-end align-items-center"></div>
                        <!-- col end-->
                        <div class="col-lg-2 col-md-12 col-sm-2 d-flex justify-content-start align-items-center">
                            <label name="Notes" class="col-form-label col-form-label-sm required"> Notes </label>
                        </div>
                        <!-- col end-->
                        <div class="col-lg-4 col-md-12 col-sm-4 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                            <textarea v-model="selectedTask.agentTaskNotes" data-vv-name="notes" v-validate="'required'" spellcheck="true" placeholder="Enter message here" class="form-control input-sm" rows="5" :maxlength="500" />
                            <div v-if="errors.has('notes')" class="alert-danger">{{ errors.first('notes') }}</div>
                        </div>
                        <!-- col end-->
                    </div>
                    <!--row end-->
                    <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 p-2">
                        <div class="col-lg-4 col-md-4 col-sm-4 d-flex justify-content-lg-end align-items-center">
                            <button type="submit" @click="updateDealer" class="btn btn-secondary">Submit</button>&nbsp;&nbsp;&nbsp;
                            <button class="btn btn-secondary" type="submit" @click="resetsearch">Reset</button>
                        </div>
                        <!-- col end-->
                    </div>
                    <!--row end-->
                    <br />
                    <br />
                </div>
                <div class="hide" v-if="selectedTask.activityTaskD === 'NDDV'">
                    <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 p-2">

                        <div class="col-lg-3 col-md-12 col-sm-3 d-flex justify-content-start align-items-center">
                            <input type="checkbox" class="pr-2" v-model="checked" disabled />
                            <label class="form-check-label ml-2 required" for="askdecline"> Ask for Declines</label>
                        </div>
                        <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                            <input type="text" id="dname" placeholder="Enter Ask For Declines" class="form-control input-sm" v-validate="'required'" data-vv-name="declines" name="source" v-model.trim="selectedTask.trackerPaperWork" />
                            <div v-if="errors.has('declines')" class="alert-danger">{{ errors.first('declines') }}</div>
                        </div>
                        <!-- col end-->
                    </div>
                    <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 p-2">

                        <div class="col-lg-3 col-md-12 col-sm-3 d-flex justify-content-start align-items-center">
                             <input type="checkbox" v-model="checked" class="pr-2" disabled />
                            <label class="form-check-label required ml-2">Make sure documents are filled</label>
                        </div>
                        <!-- col end-->
                        <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                            <select v-validate="'required'" data-vv-name="Document" class="form-control input-sm" v-model.trim="selectedTask.uDocumentFillStatus">
                                <option :value="null" disabled>Select Yes/No</option>
                                <option>Yes</option>
                                <option>No</option>
                            </select>
                            <div v-if="errors.has('Document')" class="alert-danger">{{ errors.first('Document') }}</div>
                        </div>
                        <!-- col end-->
                    </div>
                    <!--row end-->
                    <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 p-2">

                        <div class="col-lg-3 col-md-12 col-sm-3 d-flex justify-content-start align-items-center">
                            <input type="checkbox" v-model="checked" class="pr-2" disabled />
                            <label class="form-check-label required ml-2">VAIG (tell us who and contact info)</label>
                        </div>
                        <!-- col end-->
                        <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                            <input type="text" v-validate="'required'" placeholder="Enter VAIG" class="form-control input-sm" data-vv-name="vaig" v-model.trim="selectedTask.uVaigContact" />
                            <div v-if="errors.has('vaig')" class="alert-danger">{{ errors.first('vaig') }}</div>
                        </div>
                        <!-- col end-->
                    </div>
                    <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 p-2">

                        <div class="col-lg-3 col-md-12 col-sm-3 d-flex justify-content-start align-items-center">
                             <input type="checkbox" v-model="checked" class="pr-2" disabled />
                            <label for="inventory" class="form-check-label ml-2">Scan Inventory</label>
                        </div>
                        <!-- col end-->
                        <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                            <input type="text" placeholder="Enter Scan Inventory" class="form-control input-sm" v-model="selectedTask.uInventoryDetails" />
                        </div>
                        <!-- col end-->
                    </div>
                    <!--row end-->
                    <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 p-2">

                        <div class="col-lg-3 col-md-12 col-sm-3 d-flex justify-content-start align-items-center">
                            <input type="checkbox" v-model="checked" class="pr-2" disabled />
                            <label for="agree" class="form-check-label ml-2">Spend time with Sales and F&I</label>
                        </div>
                        <!-- col end-->
                        <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                            <select v-model="selectedTask.uSpendTimeResponse" class="form-control input-sm">
                                <option :value="null" disabled>Select</option>
                                <option>No</option>
                                <option>YES F&I</option>
                                <option>Yes Sales</option>
                                <option>Yes Both</option>
                            </select>
                        </div>
                        <!-- col end-->
                        <div class="col justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"></div>
                        <!-- col end-->
                        <div class="col justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">

                            <input type="text" :hidden="!newtime" v-model="selectedTask.uSpendTimeDetails" class="form-control input-sm" />
                        </div>
                        <!-- col end-->
                    </div>
                    <!--row end-->
                    <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 p-2">

                        <div class="col-lg-3 col-md-12 col-sm-2 d-flex justify-content-start align-items-center">
                            <input type="checkbox" v-model="checked" class="pr-2" disabled />
                            <label for="agree" class="form-check-label ml-2">Re-establish Credit Relationship</label>
                        </div>
                        <!-- col end-->
                        <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                            <select v-model="selectedTask.uCreditRelationshipResponse" class="form-control input-sm">
                                <option :value="null" disabled>Select</option>
                                <option>No, Already Engaged</option>
                                <option>Yes, left Card</option>
                                <option>Yes, Called Credit</option>
                                <option>Yes, Credit Follow-up</option>
                            </select>
                        </div>
                        <!-- col end-->
                        <div class="col justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"></div>
                        <!-- col end-->
                        <div class="col justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                            <input type="text" v-model="selectedTask.uCreditRelationshipDetails" class="form-control input-sm" v-if="selectedTask.uCreditRelationshipDetails" />
                            <input type="text" v-model="selectedTask.uCreditRelationshipDetails" class="form-control input-sm" :hidden="!newreestablish" v-else />
                        </div>
                        <!-- col end-->
                    </div>
                    <!--row end-->
                    <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 p-2">

                        <div class="col-lg-3 col-md-12 col-sm-3 d-flex justify-content-start align-items-center">
                            <label name="Notes" class="col-form-label col-form-label-sm ml-lg-4 required"> Notes </label>
                        </div>
                        <!-- col end-->
                        <div class="col-lg-4 col-md-12 col-sm-4 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                            <textarea v-model.trim="selectedTask.agentTaskNotes" data-vv-name="notes" v-validate="'required'" spellcheck="true" placeholder="Enter message here" class="form-control input-sm" rows="5" :maxlength="500" />
                            <div v-if="errors.has('notes')" class="alert-danger">{{ errors.first('notes') }}</div>
                        </div>
                        <!-- col end-->
                    </div>
                    <!--row end-->
                    <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 p-2">
                        <div class="col-lg-4 col-md-4 col-sm-4 d-flex justify-content-lg-end align-items-center">
                            <button type="submit" @click="updateDealer" class="btn btn-secondary">Submit</button>&nbsp;&nbsp;&nbsp;
                            <button class="btn btn-secondary" type="submit" @click="resetsearch">Reset</button>
                        </div>
                        <!-- col end-->
                    </div>
                    <!--row end-->
                    <br />
                    <br />
                </div>
                <div v-if="selectedTask.activityTaskD==='COAU'">
                    <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 p-2">
                        <div class="col-lg-1 col-md-1 col-sm-1 d-flex justify-content-end align-items-center"></div>
                        <!-- col end-->
                        <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                            <label class="col-form-label col-form-label-sm">Name Corporate Owner</label>
                        </div>
                        <!-- col end-->
                        <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                            <input type="text" class="form-control input-sm" placeholder="Enter Name Corporate Owner" v-model="selectedTask.uCorporateOwnerName" />
                        </div>
                        <!-- col end-->
                        <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                            <label class="col-form-label col-form-label-sm">Identify Contacts</label>
                        </div>
                        <!-- col end-->
                        <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                            <input type="text" class="form-control input-sm" placeholder="Enter Identify Contacts" v-model="selectedTask.uIdentityContact" />
                        </div>
                        <!-- col end-->
                    </div>
                    <!--row end-->
                    <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 p-2">

                        <div class="col-lg-3 col-md-12 col-sm-3 d-flex justify-content-start align-items-center ml-lg-4">
                            <input id="agree" class="pr-2 ml-2" type="checkbox" value="agree" v-model="checked" disabled />
                            <label for="agree" class="col-form-label col-form-label-sm ml-2">Capture All Contacts</label>
                        </div>
                        <!-- col end-->
                    </div>
                    <!--row end-->
                    <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 p-2">
                        <div class="col-lg-1 col-md-1 col-sm-1 d-flex justify-content-lg-end align-items-center"></div>
                        <!-- col end-->
                        <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                            <label class="col-form-label col-form-label-sm">Bussiness Title</label>
                        </div>
                        <!-- col end-->
                        <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                            <input type="text" class="form-control input-sm" placeholder="Enter Bussiness Title" v-model="selectedTask.businessTitle" />
                        </div>
                        <!-- col end-->
                        <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                            <label class="col-form-label col-form-label-sm">Name</label>
                        </div>
                        <!-- col end-->
                        <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                            <input type="text" class="form-control input-sm" placeholder="Enter Name" v-model="selectedTask.businessFullName" />
                        </div>
                        <!-- col end-->
                    </div>
                    <!--row end-->
                    <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 p-2">
                        <div class="col-lg-1 col-md-1 col-sm-1 d-flex justify-content-end align-items-center"></div>
                        <!-- col end-->
                        <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                            <label class="col-form-label col-form-label-sm">Contact Number</label>
                        </div>
                        <!-- col end-->
                        <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                            <input type="text" class="form-control input-sm" placeholder="Enter Contact Number" v-model="selectedTask.contactNumber" />
                        </div>
                        <!-- col end-->
                    </div>
                    <!--row end-->
                    <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 p-2">

                        <div class="col-lg-3 col-md-12 col-sm-3 d-flex justify-content-start align-items-center ">
                            <input id="agree" type="checkbox" class="ml-lg-4" value="agree" v-model="checked" disabled />
                            <label for="agree" class="col-form-label col-form-label-sm ml-2">Establish Credit Relationship</label>
                        </div>
                        <!-- col end-->
                        <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                            <select v-model="selectedTask.uCreditRelationshipResponse" class="form-control input-sm">
                                <option :value="null" disabled>Select</option>
                                <option>No, Already Engaged</option>
                                <option>Yes, left Card</option>
                                <option>Yes, Called Credit</option>
                                <option>Yes, Credit Follow-up</option>
                            </select>
                        </div>
                        <!-- col end-->
                        <div class="col justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                            <input type="text" class="form-control input-sm" v-model="selectedTask.uCreditRelationshipDetails" />
                        </div>
                        <!-- col end-->
                    </div>
                    <!--row end-->
                    <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 p-2">
                        <div class="col-lg-1 col-md-1 col-sm-1 d-flex justify-content-end align-items-center"></div>
                        <!-- col end-->
                        <div class="col-lg-2 col-md-12 col-sm-2 d-flex justify-content-start align-items-center">
                            <label name="Notes" class="col-form-label col-form-label-sm required"> Notes </label>
                        </div>
                        <!-- col end-->
                        <div class="col-lg-4 col-md-12 col-sm-4 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                            <textarea v-model.trim="selectedTask.agentTaskNotes" data-vv-name="notes" class="form-control input-sm" v-validate="'required'" spellcheck="true" placeholder="Enter message here" rows="5" :maxlength="500" />
                            <div v-if="errors.has('notes')" class="alert-danger">{{ errors.first('notes') }}</div>
                        </div>
                        <!-- col end-->
                    </div>
                    <!--row end-->
                    <br />
                    <br />
                    <br />
                    <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 mb-5 ml-3 ml-lg-0">
                        <div class="col-lg-4 col-md-4 col-sm-4 d-flex justify-content-lg-end align-items-center">
                            <button type="submit" @click="updateDealer" class="btn btn-secondary">Submit</button>&nbsp;&nbsp;&nbsp;
                            <button class="btn btn-secondary" type="submit" @click="resetsearch">Reset</button>
                        </div>
                        <!-- col end-->
                    </div>
                    <!--row end-->
                    <br />
                    <br />
                </div>
                <div v-if="selectedTask.activityTaskD === 'ET'">
                    <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 p-2">

                        <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                            <label class="col-form-label col-form-label-sm">Name Corporate Owner</label>
                        </div>
                        <!-- col end-->
                        <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                            <input type="text" class="form-control input-sm" placeholder="Enter Name Corporate Owner" v-model="selectedTask.uCorporateOwnerName" />
                        </div>
                        <!-- col end-->
                    </div>
                    <!--row end-->
                    <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 p-2">
                        <div class="col-12 col-md-12 justify-content-lg-end align-items-center">
                            <label name="Notes" class="col-form-label col-form-label-sm required ml-lg-5"> Notes </label>
                        </div>
                        <div class="col-lg-4 col-md-12 col-sm-4 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                            <textarea v-model.trim="selectedTask.agentTaskNotes" data-vv-name="notes" class="form-control input-sm" v-validate="'required'" spellcheck="true" placeholder="Enter message here" rows="5" :maxlength="500" />
                            <div v-if="errors.has('notes')" class="alert-danger">{{ errors.first('notes') }}</div>
                        </div>
                        <!-- col end-->
                    </div>
                    <!--row end-->
                    <br />
                    <br />
                    <br />
                    <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 mb-5 ml-3 ml-lg-0">
                        <div class="col-lg-4 col-md-4 col-sm-4 d-flex justify-content-lg-end align-items-center">
                            <button type="submit" @click="updateDealer" class="btn btn-secondary">Submit</button>&nbsp;&nbsp;&nbsp;
                            <button class="btn btn-secondary" type="submit" @click="resetsearch">Reset</button>
                        </div>
                        <!-- col end-->
                    </div>
                    <!--row end-->
                    <br />
                    <br />
                </div>
                <div v-if="selectedTask.activityTaskD === 'DSRT'">
                    <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 p-2">
                        <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                            <label class="col-form-label col-form-label-sm ml-lg-5">Field Dealer Support Questions</label>
                        </div>
                        <!-- col end-->
                        <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                            <input type="text" placeholder="Enter Field Dealer Support Questions" class="form-control input-sm" v-model="selectedTask.dealerSupport" />
                        </div>
                        <!-- col end-->
                    </div>
                    <!-- row end-->
                    <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 p-2">

                        <div class="col-12 col-md-12 d-flex justify-content-start align-items-center">
                            <label name="Notes" class="col-form-label col-form-label-sm ml-lg-5 required"> Notes </label>
                        </div>
                        <!-- col end-->
                        <div class="col-lg-4 col-md-12 col-sm-4 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                            <textarea v-model.trim="selectedTask.agentTaskNotes" data-vv-name="notes" class="form-control input-sm" v-validate="'required'" spellcheck="true" placeholder="Enter message here" rows="5" :maxlength="500" />
                            <div v-if="errors.has('notes')" class="alert-danger">{{ errors.first('notes') }}</div>
                        </div>
                        <!-- col end-->
                    </div>
                    <!--row end-->
                    <br />
                    <br />
                    <br />
                    <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 mb-5 ml-3 ml-lg-0">
                        <div class="col-lg-4 col-md-4 col-sm-4 d-flex justify-content-lg-end align-items-center">
                            <button type="submit" @click="updateDealer" class="btn btn-secondary">Submit</button>&nbsp;&nbsp;&nbsp;
                            <button class="btn btn-secondary" type="submit" @click="resetsearch">Reset</button>
                        </div>
                    </div>
                    <!-- col end-->
                    <br />
                    <br />
                </div>
                <!--row end-->
            </div>
        </div>
        <!-- End of the code for this screen here -->
        <bottom-footer></bottom-footer>
        </div>
        </div>
    </div>
</template>
<script>
import TopHeader from '@/components/TopHeader.vue'
import BottomFooter from '@/components/BottomFooter.vue'
import MainMenu from '@/components/Menu.vue'
import httpemployee from '../js/http-employee'
import httpaddtask from '../js/http-addtask.js'
import util from '../js/common-utils.js'
import moment from 'moment'
export default {
  components: {
    MainMenu,
    TopHeader,
    BottomFooter
  },
  data () {
    return {
      declines: false,
      documents: false,
      vaig: false,
      inventory: false,
      time: false,
      reestablish: false,
      newdeclines: false,
      newdocuments: false,
      newvaig: false,
      newinventory: false,
      newtime: false,
      newreestablish: false,
      allcontacts: false,
      establish: false,
      owner: false,
      saved: false,
      checked: true,
      disableemployeedd: 'false',
      failure: false,
      failureMessage: "We're sorry, We're unable to save task information at the moment, please try back later",
      headerMessage: 'Update Task',
      schedules: [],
      taskList: [],
      task: this.initializedata(),
      selectedTask: [],
      selectedRadio: '',
      // tasks: this.initialize(),
      employeelist: [],
      selectedName: { 'employeeId': 'All', 'firstName': 'All', 'inactiveD': null, 'lastName': null, 'middleName': null, 'userRoleC': null, 'userRoleX': 'Back Office' },
      selectedDate: ' ',
      documentlist: [
        {
          key: 'Yes',
          value: 'Yes'
        },
        {
          key: 'No',
          value: 'No'
        }
      ],
      heads: [
        {
          name: 'Select'
        },
        {
          name: 'Schedule Week'
        },
        {
          name: 'Salesperson Name'
        },
        {
          name: 'Activity Task'
        },
        {
          name: 'Dealer Name'
        },
        {
          name: 'Event Type'
        },
        {
          name: 'Task Update Status'
        },
        {
          name: 'Task Updated Date'
        }
      ]
    }
  },
  methods: {
    displayFullName (option) {
      return `${option.firstName} ${option.middleName != null && option.middleName.length != 0 ? ',' + option.middleName : ''} ,${option.lastName != null && option.lastName.length != 0 ? option.lastName : ''}`
    },
    colorRow: function (tskNumber) {
      if (tskNumber === this.selectedRadio) return 'selected-task'
      else return 'non-selected-task'
    },
    // for retrieving of data
    initializedata () {
      return {
        weekStart: moment().weekday(0),
        weekEnd: moment().weekday(6),
        weekstart: moment().weekday(0),
        weekend: moment().weekday(6),
        selectedapp: '',
        agentTaskId: '',
        firstName: '',
        shortNotes: '',
        agentTaskNotes: '',
        dealerName: '',
        activityType: '',
        activityTaskX: '',
        activityTaskD: '',
        employeeId: '',
        dealerId: '',
        eventType: '',
        businessTitle: '',
        businessFullName: '',
        contactNumber: '',
        dealerSupport: '',
        trackerPaperWork: '',
        uDocumentFillStatus: '',
        uVaigContact: '',
        uInventoryDetails: '',
        uSpendTimeDetails: '',
        uSpendTimeResponse: '',
        uCreditRelationshipDetails: '',
        uCreditRelationshipResponse: '',
        uCorporateOwnerName: '',
        uCorporateOwnerName: '',
        businessTitle: '',
        businessFullName: '',
        contactNumber: '',
        dealerSupport: '',
        trackerPaperWork: '',
        uDocumentFillStatus: '',
        uVaigContact: '',
        uInventoryDetails: '',
        uSpendTimeDetails: '',
        uSpendTimeResponse: '',
        uCreditRelationshipDetails: '',
        uCreditRelationshipResponse: '',
        uCorporateOwnerName: '',
        message: '',
        empId: this.$session.get('user_role') == 'SR' ? this.$session.get('employee_id') : '',
        failureMessage: "We're sorry, We're unable to save task information at the moment, please try back later"
      }
    },
    // updating of task by rest Api Call
    updateDealer () {
      this.$validator
        .validateAll()
        .then(() => {
          if (!this.errors.any()) {
            let updateDealerPayload = {
              agentTaskId: this.selectedTask.agentTaskId,
              firstName: this.selectedTask.firstName,
              startOfWeek: util.formatDateMoment(this.task.weekStart),
              endOfWeek: util.formatDateMoment(this.task.weekEnd),
              shortNotes: this.selectedTask.shortNotes,
              dealerName: this.selectedTask.dealerName,
              activityType: this.selectedTask.activityType,
              activityTaskD: this.selectedTask.activityTaskD,
              activityTaskX: this.selectedTask.activityTaskX,
              employeeId: this.selectedTask.employeeId,
              dealerId: this.selectedTask.dealerId,
              eventType: this.selectedTask.eventType,
              businessTitle: this.selectedTask.businessTitle,
              businessFullName: this.selectedTask.businessFullName,
              contactNumber: this.selectedTask.contactNumber,
              dealerSupport: this.selectedTask.dealerSupport,
              trackerPaperWork: this.selectedTask.trackerPaperWork,
              uDocumentFillStatus: this.selectedTask.uDocumentFillStatus,
              uVaigContact: this.selectedTask.uVaigContact,
              uInventoryDetails: this.selectedTask.uInventoryDetails,
              uSpendTimeDetails: this.selectedTask.uSpendTimeDetails,
              uSpendTimeResponse: this.selectedTask.uSpendTimeResponse,
              uCreditRelationshipDetails: this.selectedTask.uCreditRelationshipDetails,
              uCreditRelationshipResponse: this.selectedTask.uCreditRelationshipResponse,
              uCorporateOwnerName: this.selectedTask.uCorporateOwnerName,
              uIdentityContact: this.selectedTask.uIdentityContact,
              agentTaskNotes: this.selectedTask.agentTaskNotes
            }
            // console.log("Payload for update dealer:"+updateDealerPayload);
            // console.log("Payload for update dealer:"+JSON.stringify(updateDealerPayload))
            // Call REST API
            httpaddtask.put('/updatetask/' + this.selectedTask.agentTaskId, updateDealerPayload).then((response) => {
              var status = response.data
              if (status == 'ACCEPTED') {
                // console.log("Task Updated successfully!!");
                this.saved = true
                console.log('saved is:' + this.saved)
                this.task.message = 'Task has been updated successfully!!!'
                this.retriveSalesRepData()
                this.errors.clear()
                this.$validator.reset()
                this.selectedRadio = ''
                this.selectedTask = []
                // console.log("saved data"+JSON.stringify(this.tasklist))
              }
            })
            // Got to View Dealers?
            // this.$router.push('/viupdateDealer');
          } else if (status == 'BAD_REQUEST') {
            // console.log("Failed to update Dealer!!");
            // this.saved= false;
            this.failure = true
            this.selectedTask.message = "We're sorry there is system Error, please try again or contact us"
          } else {
            console.log('Failed to update Dealer!!')
            this.failure = true
            this.message = "We're sorry there is system Error, please try again or contact us"
          }
          // TODO= Handle following scenarios - Dealer Already exists, 500 or any other Status Codes
        })
        .catch((e) => {
          console.log('Failed: ' + e)
          this.failure = true
          this.message = "We're sorry there is system Error, please try again or contact us"
        })
      this.task = this.initializedata()
    },
    retriveemployee: function () {
      httpemployee
        .get('/employee')
        .then((response) => {
          this.employeelist = response.data
          // console.log("employee details:"+this.employeelist);
        })
        .catch((e) => {
          this.errors.push(e)
        })
    },
    // RESET
    resetsearch () {
      (this.message = ''), (this.norecordsfound = false), (this.selectedRadio = ''), (this.selectedTask = [])
    },
    // for retriving data based on Id
    viewAppDetails: function (agentTaskId, index) {
      this.selectedTask = this.taskList[index]
      this.information = ''
      this.errors.clear()
      this.$validator.reset();
      (this.declines = false),
      (this.documents = false),
      (this.vaig = false),
      (this.inventory = false),
      (this.time = false),
      (this.reestablish = false),
      (this.newdeclines = false),
      (this.newdocuments = false),
      (this.newvaig = false),
      (this.newinventory = false),
      (this.newtime = false),
      (this.newreestablish = false),
      (this.allcontacts = false),
      (this.establish = false),
      (this.owner = false)
      // console.log("task is:"+JSON.stringify( this.selectedTask))
    },
    // subtracting -7 days
    setMyDateToToday () {
      if (this.task.weekStart > this.task.weekstart) {
        this.newdate = moment(this.task.weekStart).subtract('days', 7)
        this.task.weekStart = this.newdate
      }
      if (this.task.weekEnd > this.task.weekend) {
        this.newdate = moment(this.task.weekEnd).subtract('days', 7)
        this.task.weekEnd = this.newdate
      }
      if (this.$session.get('user_role') == 'SR') {
        this.retriveSalesRepData()
      } else {
        this.displayTasks()
      }
      this.selectedTask = []
      this.selectedRadio = ''
    },
    // adding week
    addADayToMyDate () {
      this.newdate = moment(this.task.weekStart).add('days', 7)
      this.task.weekStart = this.newdate
      this.newdate = moment(this.task.weekEnd).add('days', 7)
      this.task.weekEnd = this.newdate
      if (this.$session.get('user_role') == 'SR') {
        this.retriveSalesRepData()
      } else {
        this.displayTasks()
      }
      this.selectedTask = []
      this.selectedRadio = ''
    },
    // retriving of data by using rest Api
    retrieveTasklist () {
      httpaddtask
        .get('/readTasks')
        .then((response) => {
          this.tasklist = response.data
          // console.log("saved data tasklist is"+JSON.stringify(this.tasklist))
        })
        .catch((e) => {
          this.errors.push(e)
        })
    },
    retriveSalesRepData: function () {
      if (this.$session.get('user_role') == 'SR') {
        httpaddtask
          .get('/employee/' + this.$session.get('employee_id'))
          .then((response) => {
            // console.log("Search Results:"+ JSON.stringify(response.data))
            if (response.data.length != 0) {
              // console.log('sales Rep Data : '+ this.$session.get("employee_id"))
              var viewTaskPayload = {
                repId: this.$session.get('employee_id'),
                fromDate: util.formatDateMoment(this.task.weekStart),
                toDate: util.formatDateMoment(this.task.weekEnd)
              }
              httpaddtask.post('/searchtasks', viewTaskPayload).then((response) => {
                this.taskList = response.data
                this.selectedRadio = ''
                this.selectedTask = []
                console.log('Activity to be saved:' + JSON.stringify(this.tasklist))
              })
            } else {
              this.taskList = []
            }
          })
          .catch((e) => {
            console.log('Failed to get Tasks for Sales Rep')
            this.taskList = []
          })
      } else {
        this.displayTasks()
      }
    },
    selectAllOption () {
      var viewTaskPayload = {
        fromDate: util.formatDateMoment(this.task.weekStart),
        toDate: util.formatDateMoment(this.task.weekEnd)
      }
      httpaddtask.post('/searchtasks', viewTaskPayload).then((response) => {
        this.taskList = response.data
        this.selectedRadio = ''
        this.selectedTask = []
        this.selectedName = { 'employeeId': 'All', 'firstName': 'All', 'inactiveD': null, 'lastName': null, 'middleName': null, 'userRoleC': null, 'userRoleX': 'Back Office' }
        // console.log("Activity to be saved:"+ JSON.stringify( this.tasklist))
      })
    },
    displayTasks: function () {
      if (this.selectedName.employeeId == 'All') {
        var viewTaskPayload = {
          fromDate: util.formatDateMoment(this.task.weekStart),
          toDate: util.formatDateMoment(this.task.weekEnd)
        }
      } else {
        var viewTaskPayload = {
          repId: this.selectedName.employeeId,
          fromDate: util.formatDateMoment(this.task.weekStart),
          toDate: util.formatDateMoment(this.task.weekEnd)
        }
      }
      httpaddtask.post('/searchtasks', viewTaskPayload).then((response) => {
        this.taskList = response.data
        this.selectedRadio = ''
        this.selectedTask = []
        // console.log("Activity to be saved:"+ JSON.stringify( this.tasklist))
      })
    },
    fetchdata: function () {
      if (this.$session.get('user_role') == 'SR') {
        // console.log("username"+ this.$session.get("user_role") )
        this.employeelist = [
          {
            employeeId: this.$session.get('employee_id'),
            firstName: this.$session.get('first_name'),
            lastName: this.$session.get('last_name')
          }
        ]
        this.task.empId = this.$session.get('employee_id')
        // disable the Dropdown
        this.disableemployeedd = true
      } else {
        this.disableemployeedd = false
        // create objet
        let searchEmployee = {
          firstName: '',
          lastName: '',
          roleType: '', // All Employees
          statusCode: ''
        }
        httpemployee
          .post('/employee/search/', searchEmployee)
          .then((response) => {
            this.employeelist = response.data
          })
          .catch((e) => {
            console.log('Failed to load salesagent:' + e)
          })
      }
      this.retriveSalesRepData()
    },
    myFunction () {
      var elmnt = document.getElementById('height2')
      var elmnt1 = document.getElementById('height3')
      var txt = elmnt.offsetHeight
      var width = elmnt.offsetWidth
      var txt1 = elmnt1.offsetHeight
      var ht = txt + txt1
      $('#activity').css('margin-top', txt + txt1 + 3)
    },
    menuheight () {
      var elmnt = document.getElementById('height2')
      var txt = elmnt.offsetHeight
      $('#height3').css('margin-top', txt)
    }
  },
  created () {
    window.addEventListener('resize', this.myFunction)
    window.addEventListener('resize', this.menuheight)
  },
  computed: {
    filteredTask: function () {
      var startofWeekonScreen = moment(this.task.weekStart).format('MM/DD/YYYY')
      var endofWeekonScreen = moment(this.task.weekEnd).format('MM/DD/YYYY')
      return this.tasklist.filter(function (tasks) {
        return startofWeekonScreen === moment(tasks.startOfWeek).format('MM/DD/YYYY') && endofWeekonScreen === moment(tasks.endOfWeek).format('MM/DD/YYYY')
      })
    }
  },
  mounted: function () {
    this.fetchdata()
    this.myFunction()
    this.menuheight()
  }
}
</script>
<style scoped>
.tbl-task {
  overflow: auto;
}
</style>
